export default "__VITE_ASSET__B26a5eSe__"